import React from "react";
import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    kanji: "礼",
    title: "Respectul înainte de toate",
    body:
      "Reverența nu este ritual gol. Este contractul dintre elev și artă — recunoașterea că înainte de a lovi, învățăm să ne oprim. Fiecare antrenament începe și se termină cu o plecăciune.",
  },
  {
    n: "02",
    kanji: "誠",
    title: "Disciplină fără spectacol",
    body:
      "Nu antrenăm pentru cameră. Antrenăm pentru sinele viitor. Prezența constantă, repetiția tăcută și corectitudinea gestului contează mai mult decât orice performanță de moment.",
  },
  {
    n: "03",
    kanji: "力",
    title: "Forță cu control",
    body:
      "Karate începe și se termină cu politețe. MMA începe și se termină cu control. Învățăm cum să lovim ca să nu fie nevoie s-o facem — și cum să răspundem când nu avem de ales.",
  },
  {
    n: "04",
    kanji: "道",
    title: "Un drum lung, un pas azi",
    body:
      "O centură neagră nu este destinația. Este un începător care nu s-a oprit. Fiecare copil, adolescent sau adult din sală parcurge același drum: mic, azi.",
  },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.15 } },
};
const item = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

const NumberedManifesto = () => {
  return (
    <section id="manifest" className="section" data-testid="manifesto-section">
      <div className="container-brutal">
        {/* Section header */}
        <div className="grid grid-cols-12 gap-6 mb-20 md:mb-28">
          <div className="col-span-12 md:col-span-3 flex items-start gap-4">
            <span className="eyebrow">§ 01 / Manifest</span>
          </div>
          <div className="col-span-12 md:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="section-title"
            >
              Patru principii.<br />
              <span className="text-[#D91604]">O singură</span> disciplină.
            </motion.h2>
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="editorial-lead mt-8 max-w-2xl text-[#8a8a8a]"
            >
              La Elite Center nu vindem centuri, ci un cod de conduită.
              Ceea ce urmează sunt regulile pe care le respectăm — pe tatami și în afara lui.
            </motion.p>
          </div>
        </div>

        {/* Chapters */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-16 md:gap-y-24"
        >
          {chapters.map((c, i) => (
            <motion.article
              key={c.n}
              variants={item}
              className={`relative grid grid-cols-12 gap-4 ${i % 2 === 1 ? "md:mt-24" : ""}`}
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div className="col-span-3 md:col-span-4 flex flex-col items-start">
                <div className="chapter-number">{c.n}</div>
                <div className="font-jp text-4xl mt-2 text-[#f2ebe5]/70">{c.kanji}</div>
              </div>
              <div className="col-span-9 md:col-span-8 pt-3">
                <h3 className="font-anton text-3xl md:text-4xl uppercase tracking-tight leading-none mb-6">
                  {c.title}
                </h3>
                <p className="font-editorial italic text-lg md:text-xl leading-relaxed text-[#f2ebe5]/85">
                  {c.body}
                </p>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default NumberedManifesto;
